/* eslint-disable */
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styles from './index.module.scss';

interface Props extends RouteComponentProps {
  apiId: number,
  title: string
}

const SubProductItem: React.FC<Props> = ({ apiId, title, history }) => {
  const handlerClick = () => {
    history.push(`/apidetail/${apiId}`);
  };
  return (
    <div onClick={handlerClick} className={styles.subProductLay}>
      <div className={styles.txt}>{title}</div>
      <div className={styles.img_wraps}>
        <img src="https://www.sagamarket.io/img/icons/Tool.svg" alt="" />
      </div>
    </div>
  );
};

export default withRouter(SubProductItem);
